import { format } from 'date-fns';


export function dateTime(dateString) {
    const date = new Date(dateString);
    return format(date, 'yyyy-MM-dd');
}